module.exports = __webpack_public_path__ + "static/media/Upload.4bf24552.svg";